import {
    GET_DISCREPANCY_DATA_SUCCESS,
    GET_ORDER_STATUS_DETAILS,
    GET_ORDER_STATUS_DETAILS_FAILURE,
    GET_ORDER_STATUS_DETAILS_SUCCESS,
    REPORT_USG_OBJ,
    SET_DISCREPANCY_EMAIL,
    SET_DISCREPANCY_USAGE_VALUE_EXISTS,
    SET_IS_CONFIRMATION_BOX_CHECKED,
    SET_PHYSICIAN_PROCEDURE_DROPDOWN,
    SET_PHYSICIAN_TEXT_DATA,
    SET_PROCEDURE_DATA,
    GET_DISCREPANCY_DATA_FAILURE,
    RESET_REPORT_USAGE_STATES,
    RESET_VALIDATED_DATA,
    STORE_SURGERY_DETAILS,
    SET_PATIENT_DETAILS,
    STORE_ITEM_TABLE_DATA,
    GET_USAGE_DETAILS,
    GET_USAGE_DETAILS_SUCCESS,
    GET_USAGE_DETAILS_FAILURE,
    GET_USAGE_DETAILS_DISCREPENCY_SUCCESS,
    GET_USAGE_DETAILS_DISCREPENCY_FAILURE,
    GET_PRICES_FOR_ITEMS,
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    SET_ITEMS_DURING_PRICING,
    GET_DROPDOWN_OPTIONS_SUCCESS,
    GET_DROPDOWN_OPTIONS_FAILURE,
    VALIDATE_MAZOR_CODE,
    VALIDATE_MAZOR_CODE_RESPONSE,
    SET_ADVANCE_ENERGY_DATA,
    GET_PROCEDURE_INFO,
    GET_PROCEDURE_INFO_SUCCESS,
    GET_PROCEDURE_INFO_FAILURE,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    VALIDATE_REPLEN_PRODUCTS_RESPONSE,
    USAGE_ATTACHMENT_UPLOAD,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    USAGE_ATTACHMENT_UPLOAD_FAILURE,
    RESET_PO_ATTACHMENT,
    CREATE_USAGE_ORDER,
    CREATE_USAGE_ORDER_SUCCESS,
    UPDATE_USAGE_ORDER,
    UPDATE_USAGE_ORDER_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    SET_ALL_ACCOUNT_OWNED_SELECTED,
    SET_PROCEDURE_DETAILS,
    SET_UNID_SELECTED,
    SAVE_OR_REPORT_DATA,
    CLEAR_SPECFIC_DROPDOWN_LIST,
    STORE_UNID_SURGERY_INFO,
    RESET_DROPDOWN_OPTIONS,
    SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP,
    GET_IMAGE_PO_PREVIEW,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    GET_IMAGE_PO_PREVIEW_FAILURE,
    RESET_IMAGE_PO_PREVIEW,
    SET_PRICEOVERRIDE_DETAILS,
    SET_REMOVE_APPLIED_SIGNATURE,
    GET_DISCREPANCY_DATA,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE,
    RESET_DISCREPANCY_ATTACHMENT,
    UPDATE_DIS_ATTACHMENT,
    CHECK_IS_PRICEOVERRIDE_PAGE,
    STORE_USAGE_DATA_PERSIST,
    PUT_DISCREPANCY_DATA_REQUEST,
    PUT_DISCREPANCY_DATA_REQUEST_SUCCESS,
    PUT_DISCREPANCY_DATA_REQUEST_FAILURE,
    GET_DISTRICT_TERRITORY,
    USAGE_SUBMIT_CLICKED,
    RESET_DISCREPANCY_USAGE_DETAILS,
    SET_REPORT_PAYMENT_SCREEN,
    SET_REPORT_PAYMENT_FLAG,
    SET_IS_ERROR_EXIST,
    SET_TERRITORY,
    VALIDATE_UNID_PLAN_FEE_ITEMS,
    VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS,
    VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE,
    GET_DROPDOWN_OPTIONS,
    EDIT_USAGE_DETAILS,
    SET_RETRACTOR_USED_OTHER_FIELD_DATA,
    TOTAL_LEVELS_NUMBER,
    SET_LEVEL_NUMBER_ARRAY,
    VALIDATE_ACCOUNT,
    RESET_VALIDATE_ACCOUNT,
    VALIDATE_ACCOUNT_FAILURE,
    VALIDATE_ACCOUNT_SUCCESS,
    SET_PROCEDURE_DATA_JP,
    SET_PROCEDURE_VISIBILITY,
    SET_REQUEST_DELIVERY_DATE,
    UIV_FIRST_LEVEL_SELECTED,
    LIV_FIRST_LEVEL_SELECTED,
    UIV_LEVEL_ARRAY,
    LIV_LEVEL_ARRAY,
    SET_INVALID_ITEM_STATUS,
    SET_UIV_DROPDOWN_VALUE,
    SET_LIV_DROPDOWN_VALUE,
    ADD_PROCEDURE_LEVEL,
    SET_PROCEDURE_LEVEL,
    CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL,
    SET_IS_UIV_SELECTED,
    SET_IS_LIV_SELECTED,
    SET_CURR_UIV_LEVEL,
    SET_CURR_LIV_LEVEL,
    SET_CURR_ROW_ID,
    SET_PREV_PROCEDURE_ROW_LEVELS,
    GET_BARCODE_ITEMS,
    SHOW_INVALID_BARCODE_DETAILS,
    SET_BARCODE_RECEIVE_ITEMS,
    SHOW_INVALID_BARCODE_POPUP,
    RESET_INVALID_BARCODE_DETAILS,
    RESET_BARCODE_ITEMS,
    GET_BARCODE_ITEMS_FAILURE,
    GET_BARCODE_ITEMS_SUCCESS,
    RESET_PROCEDURE_DATA,
    CHECK_FIRST_LEVEL_SELECTED,
    CHECK_ERROR_FOUND_IN_FIRST_LEVEL,
    SET_MAZOR_CASE_COVERAGE_VALUE,
    RESET_MAZOR_CASE_COVERAGE_VALUE,
    CHECK_LEVEL_DATA_MODIFIED,
    SET_SURGERY_NUMBER,
    SET_REPLENISHMENT_SURGERY_NUMBER,
    VALIDATE_REPLEN,
    VALIDATE_REPLEN_SUCCESS,
    VALIDATE_REPLEN_FAILURE,
    CLEAR_VALIDATE_REPLEN,
    CLEAR_ERROR,
    SET_REPLENISHMENT_SURGERY_DATE,
    SET_PROCEDURE_VALUE,
    VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
    VALIDATE_STEALTH_CODE,
    SET_STEALTH_CASE_COVERAGE_VALUE,
    RESET_STEALTH_CASE_COVERAGE_VALUE,
    REPORT_PAYMENT_CLICKED,
    PAGE_LOADER,
} from '../action/types';
import { persistReducer } from 'redux-persist';
import { WithinTerritory } from 'src/pages/reportUsage/replen/components/replenConstant';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { RequestDeliveryDateNotification } from 'src/pages/scheduleSurgery/components/surgery/notifications/RequestDeliveryDateNotification';
import { convertAdjQuantityToOther } from 'src/pages/reportUsage/utils/adjDisposition';

const reportUsageObj = localStorage.getItem('myCaseRefUsage')
    ? JSON.parse(localStorage.getItem('myCaseRefUsage'))
    : {};

const normalizeDienFeeCodes = (dienFeeTypeItemNumbers) => {
    if (Array.isArray(dienFeeTypeItemNumbers)) {
        return dienFeeTypeItemNumbers.filter(Boolean);
    }
    if (
        typeof dienFeeTypeItemNumbers === 'string' &&
        dienFeeTypeItemNumbers.length > 0
    ) {
        return dienFeeTypeItemNumbers
            .split(',')
            .map((code) => code.trim())
            .filter(Boolean);
    }
    return [];
};
const initialState = {
    validateAccount: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    validateAccountLoading: false,
    myCaseRefId: reportUsageObj.myCaseRef ? reportUsageObj.myCaseRef : null,
    myCaseResourceType: reportUsageObj.resourceType
        ? reportUsageObj.resourceType
        : null,
    fromOrdersList: reportUsageObj.fromOrdersList
        ? reportUsageObj.fromOrdersList
        : false,
    isFromOrderDetailsModal: reportUsageObj.isFromOrderDetailsModal
        ? reportUsageObj.isFromOrderDetailsModal
        : false,
    showUnsavedChangesPopup: false,
    usageDetailsLoading: false,
    usageDetails: {},
    discrepancyUsageDetails: {},
    discrepencyUpdatedDetails: {},
    itemTableData: [],
    pricedItems: null,
    isUnidFeeItems: null,
    itemsToBePriced: [],
    isPricingInProgress: false,
    priceOverRideDetails: {},
    validateMazorCodeRes: null,
    // validateStealthAxisCodeRes:null,
    procedureInfoDetails: {},
    advanceEnergyData: {},
    validProducts: null,
    validatedReplenData: [],
    isProductsValidationInProgress: false,
    isProductValidationDone: false,
    isUsageAttachmentUploaded: false,
    reportUsageInProgress: false,
    orderProcessed: false,
    usageOrderSubmission: null,
    isdeletionDone: false,
    storedPatientDetails: {},
    storedItemTableData: [],
    storedPriceOverrideReason: '',
    pricingNotes: '',
    patientDetails: {
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
    },
    dropdownData: {},
    localSignatureDetails: {
        base64Image: '',
        dateOfSignature: '',
    },
    signatureItemState: [],
    isAllAccountOwnedSelected: false,
    setProcedureDetails: [],
    storedUnidSurgeryData: {},
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    setUnidDetails: [],
    uidOrReportForm: {
        isSurgicalPlanChanged: '',
        isLevelOfInstrumentationChanged: '',
        uiv: 'C1',
        liv: 'C1',
        isChangeToInterbodiesAndOrPSOs: '',
        anyChangeToInterbodiesAndOrPSOsTxt: '',
        isSurgeonCutTheRod: '',
        surgeonCutTheRodText: '',
        isRodBentInSagittalPlan: '',
        rodBentInSagittalPlanTxt: '',
        isSurgeonSatisfied: '',
        pjkPerformed: '',
        pjkMdtInstructed: '',
        pjkMdtImplants: '',
    },
    isOrReportValid: false,
    districts: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    territories: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    accounts: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
    discrepancyData: [],
    isDescrepancyFetchLoader: false,
    discrepancyAttachment: [],
    isPriceOverridePage: false,
    discrepancyUploadLoader: false,
    usagePersistData: {
        showReportPayment: false,
        reportPayment: [],
        submitButtonInitial: false,
    },
    discrepancyDataUpdateLoader: false,
    discrepancyAttachmentDeleteLoader: false,
    uploadStatusCode: '',
    deleteStatusCode: '',
    districtAndTerritory: {},
    procedureData: {},
    retractorUsedOtherFieldData: '',
    totalLevelsNumber: 0,
    uivFirstLevel: '',
    livFirstLevel: '',
    uivArray: [],
    livArray: [],
    levelNumberArray: [],
    currUivState: '',
    currLivState: '',
    currRowId: '',
    physicianType: 'favorites',
    physicianDropdownValue: {},
    physicianFieldText: '',
    physicianTextBoxType: 'known',
    procedureDropdownValue: {},
    uivDropdownValue: {
        uivState: '',
        isSelected: false,
    },
    livDropdownValue: {
        livState: '',
        isSelected: false,
    },
    mazorCaseCoverage: '',
    stealthCaseCoverage:'',
    procedureLevels: [],
    isFirstLevelSelected: false,
    isErrorFoundInFirstLevel: false,
    levelDataModified: false,
    isErrorFoundInProcedure: true,
    discrepancyEmailIds: [{ value: '', errorMessage: '' }],
    isSubmitClicked: false,
    restrictReviewScreen: true,
    discrepancyUsageValueExist: true,
    orderStatus: {},
    myCaseRef: '',
    isConfirmationCheckboxChecked: false,
    reportUsageObject: {},
    reportPaymentScreenName: 'Report Payment',
    reportPaymentFlag: true,
    isErrorExists: true,
    procedureDataLoading: false,
    dropDownLoading: false,
    procedureDataInfoForJapan: {},
    procedureScreenVisibility: 'false',
    requestDeliveryDate: '',
    isValidItem: false,
    billToDetails: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    barcodeDetails: {},
    invalidBarcodeDetails: [],
    isBarcodeLoading: false,
    showInvalidBarcodePopup: false,
    surgeryNumber: '',
    procedureValue:{},
    replenishmentSurgeryNumber: '',
    accountError: '',
    surgeonError: '',
    productsWithError: '',
    showShipToAddressPopup: false,
    territoryValue: WithinTerritory(),
    surgeryDate: '',
    reportPaymentClicked: false,
    pageLoading: false,
    saveAndExitClick:false
};

const reportUsageRootReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SHOW_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                invalidBarcodeDetails: action.payload,
            };
        case SHOW_INVALID_BARCODE_POPUP:
            return {
                ...state,
                showInvalidBarcodePopup: action.payload,
            };
        case RESET_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        case RESET_BARCODE_ITEMS:
            return {
                ...state,
                barcodeDetails: {},
            };
        case GET_BARCODE_ITEMS:
            return {
                ...state,
                isBarcodeLoading: true,
            };
        case GET_BARCODE_ITEMS_SUCCESS:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        case GET_BARCODE_ITEMS_FAILURE:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        case VALIDATE_ACCOUNT:
            return {
                ...state,
                validateAccountLoading: true,
            };
        case VALIDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                validateAccount: {
                    data: action.data,
                    statusCode: '10001',
                },
                validateAccountLoading: false,
            };
        case VALIDATE_ACCOUNT_FAILURE:
            return {
                ...state,
                validateAccount: {
                    data: {},
                    message: action.stausMessage,
                    statusCode: '422',
                },
                validateAccountLoading: false,
            };
        case RESET_VALIDATE_ACCOUNT:
            return {
                ...initialState,
            };
        case RESET_REPORT_USAGE_STATES:
            if (action.resetMyCaseRef) {
                localStorage.removeItem('myCaseRefUsage');
            }
            return {
                ...initialState,
                myCaseRefId: action.resetMyCaseRef
                    ? null
                    : initialState.myCaseRef,
                myCaseResourceType: action.resetMyCaseRef
                    ? null
                    : initialState.resourceType,
                fromOrdersList: action.resetMyCaseRef
                    ? false
                    : initialState.fromOrdersList,
                isFromOrderDetailsModal: action.resetMyCaseRef
                    ? false
                    : initialState.isFromOrderDetailsModal,
                patientDetails: {
                    hrefId: '',
                    patientFirstName: '',
                    patientLastName: '',
                    patientSalutation: '',
                    patientSex: '',
                },
                usageDetailsLoading: state.usageDetailsLoading
            };
        case 'SET_LOCAL_PATIENT_DETAILS':
            return {
                ...state,
                storedPatientDetails: action.payload,
            };
        case SET_ADVANCE_ENERGY_DATA:
            return {
                ...state,
                advanceEnergyData: action.payload,
            };

        case 'SET_LOCAL_USAGE_TABLE_DATA':
            return {
                ...state,
                storedItemTableData: action.payload,
            };
        case 'SET_LOCAL_PRICE_OVERRIDE_REASON':
            return {
                ...state,
                storedPriceOverrideReason: action.payload,
            };
        case 'SET_LOCAL_PRICE_COMMENTS':
            return {
                ...state,
                pricingNotes: action.payload,
            };
        case SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP:
            return {
                ...state,
                showUnsavedChangesPopup: action.payload.showPopup,
                navigationPath: action.payload.navPath,
                selectedScreenToNavigate: action.payload.selectedScreen,
            };
        case STORE_SURGERY_DETAILS:
            return {
                ...state,
                surgeryData: action.payload,
                myCaseRefId:
                    action.payload && action.payload.myCaseRef
                        ? action.payload.myCaseRef
                        : reportUsageObj.myCaseRef,
                myCaseResourceType:
                    action.payload && action.payload.resourceType
                        ? action.payload.resourceType
                        : reportUsageObj.resourceType,
                fromOrdersList:
                    action.payload && action.payload.fromOrdersList
                        ? action.payload.fromOrdersList
                        : reportUsageObj.fromOrdersList,
                isFromOrderDetailsModal:
                    action.payload && action.payload.isFromOrderDetailsModal
                        ? action.payload.isFromOrderDetailsModal
                        : reportUsageObj.isFromOrderDetailsModal,
            };
        case GET_USAGE_DETAILS:
            return {
                ...state,
                usageDetailsLoading: true,
                uploadStatusCode: '',
                deleteStatusCode: '',
            };
        case GET_USAGE_DETAILS_SUCCESS:
        case GET_USAGE_DETAILS_FAILURE:
            return {
                ...state,
                usageDetails: {
                    ...action.payload,
                    accountFormattedName: `${
                        action.payload.accountName
                    } ${accountNumberZeroTrimmer(action.payload.accountId)}`,
                    originalAccountId: action.payload.accountId,
                    originalAccountName: action.payload.accountName,
                    originalAccountFormattedName: `${
                        action.payload.accountName
                    } ${accountNumberZeroTrimmer(action.payload.accountId)}`,
                    originalIsHCPOAccountNonTissue:
                        action.payload.isHCPOAccountNonTissue,
                    originalIsHCPOAccountTissue:
                        action.payload.isHCPOAccountTissue,
                    products: Array.isArray(action.payload.products)
                        ? (() => {
                              const dienFeeCodes = normalizeDienFeeCodes(
                                  action.payload.dienFeeTypeItemNumbers
                              );
                              return convertAdjQuantityToOther(action.payload.products).map(
                                  (product) => ({
                                      ...product,
                                      isDienFeeItem:
                                          dienFeeCodes.length > 0 &&
                                          dienFeeCodes.includes(
                                              product.productCFN
                                          ),
                                  })
                              );
                          })()
                        : action.payload.products,
                },
                surgeryNumber: action.payload.surgeryNumber,
                usageDetailsLoading: false,
            };
        case EDIT_USAGE_DETAILS:
            return {
                ...state,
                usageDetails: {
                    ...state.usageDetails,
                    ...action.payload,
                },
            };
        case GET_USAGE_DETAILS_DISCREPENCY_SUCCESS:
        case GET_USAGE_DETAILS_DISCREPENCY_FAILURE:
            return {
                ...state,
                discrepancyUsageDetails: action.payload,
                usageDetailsLoading: false,
            };
        case SET_PATIENT_DETAILS:
            return {
                ...state,
                patientDetails: action.payload.patientDetails,
            };
        case SET_INVALID_ITEM_STATUS:
            return {
                ...state,
                isValidItem: action.payload,
            };
        case SET_REQUEST_DELIVERY_DATE:
            return {
                ...state,
                requestDeliveryDate: action.payload,
            };
        case STORE_ITEM_TABLE_DATA: {
            const dienFeeCodes = normalizeDienFeeCodes(
                state.usageDetails?.dienFeeTypeItemNumbers
            );
            return {
                ...state,
                itemTableData: Array.isArray(action.payload)
                    ? action.payload.map((item) => ({
                          ...item,
                          isDienFeeItem:
                              dienFeeCodes.length > 0 &&
                              dienFeeCodes.includes(item.cfn || item.productCFN),
                      }))
                    : action.payload,
            };
        }
        case SET_ITEMS_DURING_PRICING:
            return {
                ...state,
                itemsToBePriced: action.payload,
            };
        case GET_PRICES_FOR_ITEMS:
            return {
                ...state,
                isPricingInProgress: true,
            };
        case 'SET_ITEMS_PRICING_DONE_FLAG': {
            return { ...state, isPricingDone: action.payload };
        }
        case GET_PRICES_FOR_ITEMS_SUCCESS:
        case GET_PRICES_FOR_ITEMS_FAILURE:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingInProgress: false,
            };
        case RESET_VALIDATED_DATA:
            return {
                ...state,
                validProducts: null,
                isProductValidationDone: false,
                pricedItems: null,
                itemsToBePriced: [],
                isPricingInProgress: false,
                isProductsValidationInProgress: false,
            };
        case GET_DROPDOWN_OPTIONS:
            return {
                ...state,
                dropDownLoading: true,
            };
        case GET_DROPDOWN_OPTIONS_SUCCESS:
        case GET_DROPDOWN_OPTIONS_FAILURE:
            return {
                ...state,
                dropDownLoading: false,
                dropdownData: {
                    ...state.dropdownData,
                    [action.payload.dropdownName]:
                        action.payload.dropdownOptions,
                },
            };
        case RESET_DROPDOWN_OPTIONS:
            return {
                ...state,
                dropdownData: {
                    ...state.dropdownData,
                    [action.payload.dropdownName]: [],
                },
            };
        case VALIDATE_MAZOR_CODE:
            return {
                ...state,
                kitCodeValidationInProgress: true,
            };
        case VALIDATE_STEALTH_CODE:
            return {
                ...state,
                kitCodeValidationInProgress: true,
            };
        case VALIDATE_MAZOR_CODE_RESPONSE:
            return {
                ...state,
                kitCodeValidationInProgress: false,
                validateMazorCodeRes: action.payload,
            };
        // case VALIDATE_STEALTH_AXIS_CODE_RESPONSE:
        //     return {
        //         ...state,
        //         kitCodeValidationInProgress: false,
        //         validateStealthAxisCodeRes: action.payload,
        //     };
        case GET_PROCEDURE_INFO:
            return {
                ...state,
                procedureDataLoading:
                    action.payload?.loading === false ? false : true,
            };
        case GET_PROCEDURE_INFO_SUCCESS:
        case GET_PROCEDURE_INFO_FAILURE:
            if (!action.name) {
                return {
                    ...state,
                    procedureInfoDetails: action.payload,
                    procedureDataLoading: false,
                };
            } else {
                return {
                    ...state,
                    procedureInfoDetails: {
                        ...state.procedureInfoDetails,
                        [action.name]: action.payload,
                    },
                    procedureDataLoading: false,
                };
            }

        case VALIDATE_PRODUCT_DETAILS:
            return {
                ...state,
                isProductsValidationInProgress: true,
            };
        case VALIDATE_PRODUCT_DETAILS_SUCCESS:
        case VALIDATE_PRODUCT_DETAILS_FAILURE:
            return {
                ...state,
                validProducts: action.payload.validItems,
                isProductValidationDone: action.payload.productsValidated,
                isProductsValidationInProgress: false,
            };
        case VALIDATE_REPLEN:
            return {
                ...state,
                isProductsValidationInProgress: true,
            };
        case VALIDATE_REPLEN_SUCCESS:
        case VALIDATE_REPLEN_FAILURE:
            return {
                ...state,
                isProductsValidationInProgress: false,
                accountError: action?.accountError,
                surgeonError: action?.surgeonError,
                showShipToAddressPopup: action?.showShipToAddressPopup,
                productsWithError: action?.productsWithError,
            };
        case CLEAR_ERROR:
            return {
                ...state,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
            };
        case CLEAR_VALIDATE_REPLEN:
            return {
                ...state,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
                showShipToAddressPopup: initialState.showShipToAddressPopup,
            };
        case VALIDATE_UNID_PLAN_FEE_ITEMS:
            return {
                ...state,
                isProductsValidationInProgress: true,
            };
        case VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS:
        case VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE:
            return {
                ...state,
                // validProducts: action.payload.validItems,
                validUnidProducts: action.payload.validItems,
                isUnidFeeItems: action.payload.validItems[0].isUNiDPlanFeeItem,
                isProductValidationDone: action.payload.productsValidated,
                isProductsValidationInProgress: false,
            };
        case VALIDATE_REPLEN_PRODUCTS_RESPONSE:
            return {
                ...state,
                validatedReplenData: action.payload,
            };
        case USAGE_ATTACHMENT_UPLOAD:
            return {
                ...state,
                poImageUploadLoader: true,
            };
        case USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE:
            return {
                ...state,
                poNonTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE:
            return {
                ...state,
                poTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case USAGE_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                isUsageAttachmentUploaded: false,
                poImageUploadLoader: false,
            };
        case CREATE_USAGE_ORDER:
        case UPDATE_USAGE_ORDER:
            return {
                ...state,
                reportUsageInProgress: true,
                orderProcessed: true,
                saveAndExitClick : action.payload.clickedBtn === 'save&exit'
            };
        case CREATE_USAGE_ORDER_SUCCESS:
        case UPDATE_USAGE_ORDER_SUCCESS:
            return {
                ...state,
                usageOrderSubmission: action.payload,
                reportUsageInProgress: false,
            };
        case DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                poTissueImageDetails: action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poTissueImageDetails,
                poNonTissueImageDetails: !action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poNonTissueImageDetails,
            };
        case RESET_PO_ATTACHMENT:
            return {
                ...state,
                poTissueImageDetails: '',
                poNonTissueImageDetails: '',
            };
        case DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
            };
        case 'SET_LOCAL_SIGNATURE': {
            return {
                ...state,
                localSignatureDetails: action.payload,
            };
        }
        case 'SET_ITEM_STATE_SIGNATURE': {
            return {
                ...state,
                signatureItemState: action.payload,
            };
        }
        case SET_REMOVE_APPLIED_SIGNATURE: {
            return {
                ...state,
                removeAppliedSignature: action.payload,
            };
        }
        case SET_ALL_ACCOUNT_OWNED_SELECTED: {
            return {
                ...state,
                isAllAccountOwnedSelected: action.payload,
            };
        }
        case SET_PROCEDURE_DETAILS: {
            return {
                ...state,
                setProcedureDetails: action.payload,
            };
        }
        case SET_UNID_SELECTED: {
            return {
                ...state,
                setUnidDetails: action.payload,
            };
        }
        case SAVE_OR_REPORT_DATA: {
            return {
                ...state,
                uidOrReportForm: {
                    ...state.uidOrReportForm,
                    ...action.payload,
                },
            };
        }
        case STORE_UNID_SURGERY_INFO: {
            return {
                ...state,
                storedUnidSurgeryData: action.payload,
            };
        }
        case CLEAR_SPECFIC_DROPDOWN_LIST:
            return {
                ...state,
                [action.payload.name]: {
                    ...state[action.payload.name],
                    items: [],
                },
            };
        case GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case RESET_IMAGE_PO_PREVIEW:
        case GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        case SET_PRICEOVERRIDE_DETAILS:
            return {
                ...state,
                priceOverRideDetails: action.payload,
                // priceOverRideDetails: {
                //     ...action.payload,
                //     priceOverriddenReason: action.payload.priceOverriddenReason,
                // },
            };
        case GET_DISCREPANCY_DATA:
            return {
                ...state,
                isDescrepancyFetchLoader: true,
            };
        case GET_DISCREPANCY_DATA_SUCCESS:
            return {
                ...state,
                isDescrepancyFetchLoader: false,
                discrepancyData: action.payload,
            };
        case GET_DISCREPANCY_DATA_FAILURE:
            return {
                ...state,
                isDescrepancyFetchLoader: false,
                discrepancyData: [],
            };
        case USAGE_DISCREPANCY_ATTACHMENT_UPLOAD:
            return {
                ...state,
                discrepancyUploadLoader: true,
            };
        case USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS:
            return {
                ...state,
                discrepancyAttachment: action.payload,
                discrepancyUploadLoader: false,
                uploadStatusCode: 200,
            };
        case USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                discrepancyUploadLoader: false,
                uploadStatusCode: 500,
            };
        case DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                discrepancyAttachmentDeleteLoader: false,
                discrepancyAttachment: action.payload.existingImages,
                deleteStatusCode: 200,
            };
        case DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                discrepancyAttachmentDeleteLoader: false,
                isdeletionDone: false,
                deleteStatusCode: 500,
            };
        case RESET_DISCREPANCY_ATTACHMENT:
            return {
                ...state,
                discrepancyAttachment: action.payload,
            };
        case RESET_DISCREPANCY_USAGE_DETAILS:
            return {
                ...state,
                discrepancyAttachment: action.payload,
                discrepancyUsageDetails: {},
            };
        case UPDATE_DIS_ATTACHMENT:
            return {
                ...state,
                discrepancyAttachment: action.payload,
            };
        case CHECK_IS_PRICEOVERRIDE_PAGE:
            return {
                ...state,
                isPriceOverridePage: action.payload,
            };
        case STORE_USAGE_DATA_PERSIST:
            return {
                ...state,
                usagePersistData: {
                    ...state.usagePersistData,
                    [action.payload.name]: action.payload.value,
                },
            };
        case PUT_DISCREPANCY_DATA_REQUEST:
            return {
                ...state,
                discrepancyDataUpdateLoader: true,
            };
        case PUT_DISCREPANCY_DATA_REQUEST_SUCCESS:
            return {
                ...state,
                discrepancyDataUpdateLoader: false,
                discrepencyUpdatedDetails: action.payload,
            };
        case PUT_DISCREPANCY_DATA_REQUEST_FAILURE:
            return {
                ...state,
                discrepancyDataUpdateLoader: false,
                discrepencyUpdatedDetails: action.payload,
            };
        case GET_DISTRICT_TERRITORY:
            return {
                ...state,
                districtAndTerritory: action.payload,
            };
        case SET_PROCEDURE_DATA:
            return {
                ...state,
                procedureData: JSON.parse(JSON.stringify(action.payload)),
            };
        case SET_PROCEDURE_VALUE:
            return {
                ...state,
                procedureValue: action.payload,
            };
        case SET_PROCEDURE_DATA_JP:
            return {
                ...state,
                procedureDataInfoForJapan: {
                    ...state.procedureDataInfoForJapan,
                    [action.name]: action.payload,
                },
            };
        case SET_PROCEDURE_VISIBILITY:
            return {
                ...state,
                procedureScreenVisibility: action.name,
            };

        case RESET_PROCEDURE_DATA:
            return {
                ...state,
                procedureData: {},
                procedureInfoDetails: {},
                livDropdownValue: [],
                uivDropdownValue: [],
                uivFirstLevel: [],
                livFirstLevel: [],
                procedureLevels: [],
                livArray: [],
                uivArray: [],
            };
        case SET_RETRACTOR_USED_OTHER_FIELD_DATA:
            return {
                ...state,
                retractorUsedOtherFieldData: action.payload,
            };
        case TOTAL_LEVELS_NUMBER:
            return {
                ...state,
                totalLevelsNumber: action.payload,
            };
        case UIV_FIRST_LEVEL_SELECTED:
            return {
                ...state,
                uivFirstLevel: action.payload,
            };
        case LIV_FIRST_LEVEL_SELECTED:
            return {
                ...state,
                livFirstLevel: action.payload,
            };
        case UIV_LEVEL_ARRAY:
            return {
                ...state,
                uivArray: Array.isArray(action.payload)
                    ? [...action.payload]
                    : [],
            };
        case LIV_LEVEL_ARRAY:
            return {
                ...state,
                livArray: Array.isArray(action.payload)
                    ? [...action.payload]
                    : [],
            };
        case SET_LEVEL_NUMBER_ARRAY:
            return {
                ...state,
                levelNumberArray: action.payload,
            };
        case SET_CURR_UIV_LEVEL:
            return {
                ...state,
                currUivState: action.payload,
            };
        case SET_SURGERY_NUMBER:
            return {
                ...state,
                surgeryNumber: action.payload,
            };
        case SET_REPLENISHMENT_SURGERY_NUMBER:
            return {
                ...state,
                replenishmentSurgeryNumber: action.payload,
            };
        case SET_REPLENISHMENT_SURGERY_DATE:
            return {
                ...state,
                surgeryDate: action.payload,
            };
        case SET_CURR_LIV_LEVEL:
            return {
                ...state,
                currLivState: action.payload,
            };
        case SET_CURR_ROW_ID:
            return {
                ...state,
                currRowId: action.payload,
            };
        case SET_PREV_PROCEDURE_ROW_LEVELS:
            return {
                ...state,
                procedureLevels: action.payload,
            };
        case SET_PHYSICIAN_PROCEDURE_DROPDOWN:
            return {
                ...state,
                procedureDropdownValue: action.payload.procedureDropdownValue
                    ? action.payload.procedureDropdownValue
                    : state.procedureDropdownValue,
                physicianDropdownValue: action.payload.physicianDropdownValue
                    ? action.payload.physicianDropdownValue
                    : state.physicianDropdownValue,
                physicianType: action.payload.physicianType
                    ? action.payload.physicianType
                    : state.physicianType,
            };
        case SET_PHYSICIAN_TEXT_DATA:
            return {
                ...state,
                physicianFieldText: action.payload.physicianFieldText !== undefined
                    ? action.payload.physicianFieldText
                    : state.physicianFieldText,
                physicianTextBoxType: action.payload.physicianTextBoxType
                    ? action.payload.physicianTextBoxType
                    : state.physicianTextBoxType,
            };
        case SET_MAZOR_CASE_COVERAGE_VALUE:
            return {
                ...state,
                mazorCaseCoverage: action.payload,
            };
        case RESET_MAZOR_CASE_COVERAGE_VALUE:
            return {
                ...state,
                mazorCaseCoverage: '',
            };
        case SET_STEALTH_CASE_COVERAGE_VALUE:
            return {
                ...state,
                stealthCaseCoverage: action.payload,
            };
        case RESET_STEALTH_CASE_COVERAGE_VALUE:
            return {
                ...state,
                stealthCaseCoverage: '',
            };
        case SET_UIV_DROPDOWN_VALUE:
            return {
                ...state,
                uivDropdownValue: {
                    ...state.uivDropdownValue,
                    uivState: action.payload,
                },
            };
        case SET_LIV_DROPDOWN_VALUE:
            return {
                ...state,
                livDropdownValue: {
                    ...state.livDropdownValue,
                    livState: action.payload,
                },
            };
        case SET_IS_UIV_SELECTED:
            return {
                ...state,
                uivDropdownValue: {
                    ...state.uivDropdownValue,
                    isSelected: action.payload,
                },
            };
        case SET_IS_LIV_SELECTED:
            return {
                ...state,
                livDropdownValue: {
                    ...state.livDropdownValue,
                    isSelected: action.payload,
                },
            };
        case ADD_PROCEDURE_LEVEL:
            return {
                ...state,
                procedureLevels: [...state.procedureLevels, action.payload],
            };
        case SET_PROCEDURE_LEVEL:
            return {
                ...state,
                procedureLevels: action.payload,
            };
        case CHECK_FIRST_LEVEL_SELECTED:
            return {
                ...state,
                isFirstLevelSelected: action.payload,
            };
        case CHECK_ERROR_FOUND_IN_FIRST_LEVEL:
            return {
                ...state,
                isErrorFoundInFirstLevel: action.payload,
            };
        case CHECK_LEVEL_DATA_MODIFIED:
            return {
                ...state,
                levelDataModified: action.payload,
            };
        case CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL:
            return {
                ...state,
                isErrorFoundInProcedure: action.payload,
            };
        case SET_DISCREPANCY_EMAIL:
            return {
                ...state,
                discrepancyEmailIds: action.payload,
            };
        case USAGE_SUBMIT_CLICKED:
            return {
                ...state,
                isSubmitClicked: action.payload,
                restrictReviewScreen: false,
            };

        case SET_DISCREPANCY_USAGE_VALUE_EXISTS:
            return {
                ...state,
                discrepancyUsageValueExist: action.payload,
            };
        case GET_ORDER_STATUS_DETAILS:
            return {
                ...state,
                myCaseRef: action.payload,
            };
        case GET_ORDER_STATUS_DETAILS_SUCCESS:
        case GET_ORDER_STATUS_DETAILS_FAILURE:
            return {
                ...state,
                orderStatus: action.payload,
            };
        case SET_IS_CONFIRMATION_BOX_CHECKED:
            return {
                ...state,
                isConfirmationCheckboxChecked: action.payload,
            };
        case REPORT_USG_OBJ:
            return {
                ...state,
                reportUsageObject: action.payload,
            };
        case SET_REPORT_PAYMENT_SCREEN:
            return {
                ...state,
                reportPaymentScreenName: action.payload,
            };
        case SET_REPORT_PAYMENT_FLAG:
            return {
                ...state,
                reportPaymentFlag: action.payload,
            };
        case SET_IS_ERROR_EXIST:
            return {
                ...state,
                isErrorExists: action.payload,
            };
        case SET_TERRITORY:
            return {
                ...state,
                territoryValue: action.payload,
            };
        case REPORT_PAYMENT_CLICKED:
            return {
                ...state,
                reportPaymentClicked: action.payload,
            };
        case PAGE_LOADER:
            return {
                ...state,
                pageLoading: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

// export default reportUsageRootReducer;
export default persistReducer(
    {
        key: 'reportUsageReducer',
        storage: storage,
        whitelist: [
            'myCaseRefId',
            'myCaseResourceType',
            'usageDetails',
            'storedItemTableData',
            'storedPatientDetails',
            'patientDetails',
            'procedureInfoDetails',
            'usagePersistData',
            'storedPriceOverrideReason',
            'pricingNotes',
            'localSignatureDetails',
            'usageOrderSubmission',
            'procedureData',
            'itemTableData',
            'physicianType',
            'physicianDropdownValue',
            'physicianFieldText',
            'physicianTextBoxType',
            'procedureDropdownValue',
            'uidOrReportForm',
            'storedUnidSurgeryData',
            'discrepancyEmailIds',
            'discrepencyUpdatedDetails',
            'discrepancyAttachment',
            'fromOrdersList',
            'isSubmitClicked',
            'priceOverRideDetails',
            'signatureItemState',
            'orderStatus',
            'isConfirmationCheckboxChecked',
            'reportUsageObject',
            'orderProcessed',
            'restrictReviewScreen',
            'reportPaymentScreenName',
            'isErrorExists',
            'procedureDataVsibilityForJapan',
            'procedureScreenVisibility',
            'requestDeliveryDate',
            'isValidItem',
            'procedureLevels',
            'levelDataModified',
            'uivDropdownValue',
            'livDropdownValue',
            'livArray',
            'uivArray',
            'totalLevelsNumber',
            'levelNumberArray',
            'uivFirstLevel',
            'livFirstLevel',
            'isErrorFoundInProcedure',
            'isErrorFoundInFirstLevel',
            'isFirstLevelSelected',
            'surgeryNumber',
            'replenishmentSurgeryNumber',
            'surgeryDate',
            'procedureValue',
            'saveAndExitClick'
        ],
    },
    reportUsageRootReducer
);
